import { render } from "./form-basic.vue?vue&type=template&id=5afb34ea&lang=pug"
import script from "./form-basic.vue?vue&type=script&lang=js"
export * from "./form-basic.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__